import { Grid, Popover } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadPlans } from '../../actions';
import { setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { useNavigate } from "react-router-dom";
import setToast from '../../helpers/toaster.helper';
import { AddNewTierDarkIcon, AddNewTierIcon } from "../../icon";
import { ProductType } from "../../models/add-phone-number.model";
import { FeaturesModel, mapToFeature } from '../../models/features.model';
import { PlanModel, PlanType, TierModificationType } from "../../models/plans.model";
import * as selector from '../../selectors/selectors';
import { FeatureService } from '../../services/FeatureService';
import { UtilityService } from "../../services/UtilityService";
import { PlansService } from "../../services/plans.service";
import AddOn from "../plans/add-on.component";
import PlanCard from "../plans/plan-card.component";
import { AppRoutes } from "../routes/route.path";
import Confirm_Dialog from "../shared/confirm-dialog.component";
import { ProductTypeLabel, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import FilterComponent from "../shared/filters/filter.component";
import AddNewAddOnComponent from "./add-addon";
import { CustomFilterCategory, } from "../shared/filters/filter.model";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TierLoader from "../shared/loaders/tiers-loader.json";
import PageHeaderComponent from "../shared/page-header.component";
import SubpageHeaderComponent from "../shared/subpage-header.component";
import { ToasterType } from '../shared/toaster/toaster.model';

interface Props {
}

const Tier = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Addons: PlanModel[] = useSelector(selector.addons)
    const Plans: PlanModel[] = useSelector(selector.plans).filter(x => x.Type === PlanType.TIER)
    const LoadingPlans: boolean = useSelector(selector.loadingPlans)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [show, setShow] = useState(false);
    const [IsAddNewAddOn, setIsAddNewAddOn] = useState(false);
    const [text, setText] = useState('');
    const [planID, setPlanID] = useState('');
    const [action, setAction] = useState('');
    const [showTierForm, setShowTierForm] = useState(false);
    const [tierModificationType, setTierModificationType] = useState(TierModificationType.ADD);
    const [showAddOnOptions, setShowAddOnOptions] = useState(true);
    const [allFeatures, setAllFeatures] = useState<FeaturesModel[]>([]);
    const [searchText, setSearchText] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showFilterOptions, setShowFilterOptions] = useState(false);
    const [IsEdit, setIsEdit] = useState(false);
    const [IsDuplicate, setIsDuplicate] = useState(false);

    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>(
        [
            {
                Id: 1,
                Title: "Status",
                IsSelectedAll: false,
                Options: [{
                    Key: "IsDeleted",
                    Id: "1",
                    Label: 'Enabled',
                    Value: false,
                    IsSelected: false
                }, {
                    Key: "IsDeleted",
                    Id: "2",
                    Label: 'Disabled',
                    Value: true,
                    IsSelected: false
                }]
            },
            {
                Id: 2,
                Title: "Plan Type",
                IsSelectedAll: false,
                Options: Object.values(PlanType)
                    .filter((x) => typeof x === "number")
                    .map((type: any, index) => {
                        return {
                            Key: "Type",
                            Id: `${index}`,
                            Label: type === PlanType.TIER ? "Plans" : "Add-On",
                            Value: type,
                            IsSelected: false
                        }
                    })
            },
            {
                Id: 3,
                Title: "Product Type",
                IsSelectedAll: false,
                Options: Object.values(ProductType)
                    .filter((x) => typeof x === "number")
                    .map((type: any, index) => {
                        return {
                            Key: "Product",
                            Id: `${index}`,
                            Label: type === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : type === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : type === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING,
                            Value: type,
                            IsSelected: false
                        }
                    })
            }
        ]
    )

    useEffect(() => {
        FeatureService.getAllFeature().then(res => {
            setAllFeatures(res.data.map(mapToFeature));
        }).catch(err => {
            console.log("err:", err)
        })
        LoadPlans(dispatch);
        setRefreshHandler(() => LoadPlans(dispatch))
        setHeaderTitle("Plans")
    }, [])

    const closeTierForm = (isConfirm: boolean) => {
        setShowTierForm(false)
        setIsAddNewAddOn(false)
        setPlanID("")
        setTierModificationType(TierModificationType.ADD)
        if (!!isConfirm) {
            LoadPlans(dispatch);
        }
    };

    // const PullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadPlans(dispatch));

    const searchPlans = (e: any) => {
        setSearchText(e.target.value)
    };

    const openEditPlan = (id: string, IsAddOn?: boolean) => {
        if (IsAddOn) {
            setIsEdit(true)
            setPlanID(id)
            setIsDuplicate(false)
            setIsAddNewAddOn(IsAddOn ? IsAddOn : false)
            setShowTierForm(IsAddOn ? false : true)
        }
        else {
            navigate(AppRoutes.ADD_PLAN.replace(':PlanID', id))
        }
    }

    const handleCloseFilter = () => {

        if (IsMobileDevice) {
            setShowFilters(false)
        }
        setAnchorEl(null)
    }

    const openConfirmPlanDialog = (id: string) => {
        let text = appNote.DELETE_PLAN
        setShow(true)
        setPlanID(id)
        setText(text)
        setAction("Delete")
        setLoading(false)
    }
    const openDisablePlanDialog = (id: string) => {
        let row = Plans.find((x: any) => x.PlanID === id);
        let text = !!row?.IsDeleted ? appNote.UNHIDE_PLAN : appNote.HIDE_PLAN;
        setShow(true)
        setPlanID(id)
        setText(text)
        setAction(!!row?.IsDeleted ? "Unhide" : "Hide")
        setLoading(false)
    }

    const openDuplicatePlan = (id: string, IsAddOn?: boolean) => {
        if (IsAddOn) {
            setIsAddNewAddOn(IsAddOn ? IsAddOn : false)
            setIsDuplicate(true)
            setIsEdit(false)
            setPlanID(id)
            setShowTierForm(IsAddOn ? IsAddOn : true)
            setTierModificationType(TierModificationType.DUPLICATE)
        }
        else {
            navigate(AppRoutes.ADD_PLAN.replace(':PlanID', id + "duplicate"))
        }
    }

    const openConfirmAddOnDialog = (id: string) => {
        let text = appNote.DELETE_ADDON
        setShow(true)
        setPlanID(id)
        setText(text)
        setAction("Delete")
        setLoading(false)
    }

    const openDisableAddOnDialog = (id: string) => {
        let row = Addons.find((x: any) => x.PlanID === id);
        let text = !!row?.IsDeleted ? appNote.UNHIDE_ADDON : appNote.HIDE_ADDON;
        setShow(true)
        setPlanID(id)
        setText(text)
        setAction(!!row?.IsDeleted ? "Unhide" : "Hide")
        setLoading(false)
    }


    const filterItems = (items: PlanModel[], filterOptions: any[]): PlanModel[] => {
        const selectedOptions = filterOptions.flatMap(x => x.Options.filter(y => y.IsSelected));
        const filterObj: {
            [key: string]: any[];
        } = selectedOptions.reduce((acc, e) => {
            if (!acc[e.Key]) {
                acc[e.Key] = [e.Value];
            } else {
                acc[e.Key].push(e.Value);
            }
            return acc;
        }, {});

        return items.filter((item) => {
            for (const [key, values] of Object.entries(filterObj)) {
                if (!values.includes((item as any)[key])) {
                    return false;
                }
            }
            return true;
        });
    };


    const PlanCards = () => {
        const filteredPlans = filterItems(Plans, filterOptions);
        return filteredPlans.filter(x => searchText ? ((x.Name)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase())
            || (x.Footnote)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase())
            || (x.Price)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase())
            || (x.YearlyPrice)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase())
            || (x.Type as number === 0 ? "Main Feature" : x.Type === PlanType.TIER ? "Additional Feature" : "Additional Purchase")?.toLowerCase()?.includes(searchText.toLowerCase())) : true).map((x, i) =>
                <PlanCard
                    key={i}
                    Index={i}
                    {...x}
                    DisplayYearlyPrice={false}
                    OpenConfirmPlanDialog={openConfirmPlanDialog}
                    OpenDisablePlanDialog={openDisablePlanDialog}
                    ShowAddOnOptions={showAddOnOptions}
                    OpenEditPlan={openEditPlan}
                    Duplicate={openDuplicatePlan}
                    HideBuyNow={true}
                    IsLoading={loading}
                    IsMobileDevice={IsMobileDevice}
                />
            )
    }

    const AdOns = () => {
        const filteredAddons = filterItems(Addons, filterOptions);
        return filteredAddons.filter(x => searchText ? (x.Name)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase()) || (x.Footnote)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase()) || (x.Price)?.toString()?.toLowerCase()?.includes(searchText.toLowerCase()) || (x.Type as number === 0 ? "Main Feature" : x.Type === PlanType.TIER ? "Additional Feature" : "Additional Purchase")?.toLowerCase()?.includes(searchText.toLowerCase()) : true).map((x, i) =>
            <AddOn key={i} {...x}
                HideBuyNow={true}
                ShowAddOnOptions={showAddOnOptions}
                openConfirmAddOnDialog={openConfirmAddOnDialog}
                openDisableAddOnDialog={openDisableAddOnDialog}
                Duplicate={openDuplicatePlan}
                openEditPlan={openEditPlan}
                Index={(i + 1) % 2 === 0}
            />
        )
    }
    const DisablePlan = () => {
        setLoading(true)
        let Plan = [...Addons, ...Plans].find((x: PlanModel) => x.PlanID === planID)
        PlansService.DisablePlans(planID).then(
            () => {
                setShow(false)
                setPlanID("")
                setAction("")
                setLoading(false)
                LoadPlans(dispatch);
                setToast(!Plan?.IsDeleted ? ToasterTexts.TIER_HIDE_SUCCESS.replace('<Name>', Plan?.Name || '') : ToasterTexts.TIER_UNHIDE_SUCCESS.replace('<Name>', Plan?.Name || ''), ToasterType.SUCCESS)
            })
    }

    const DeletePlan = () => {
        setLoading(true)
        let Name = [...Addons, ...Plans].find((x: PlanModel) => x.PlanID === planID)?.Name || ''
        PlansService.deletePlan(planID).then(
            () => {
                setShow(false)
                setPlanID("")
                setAction("")
                setLoading(false)
                LoadPlans(dispatch);
                setToast(ToasterTexts.TIER_DELETE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
            })
    }

    const closeConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            setLoading(true)
            if (action === "Hide" || action === "Unhide") {
                DisablePlan();
            }
            else {
                DeletePlan();
            }
        }
        setShow(false)
        setAction("")
    };
    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (IsMobileDevice) {
            setShowFilters(true)
        }
        setAnchorEl(event.currentTarget)
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    const openAddNewAddOnPlan = (id: string) => {
        setIsAddNewAddOn(true)
        setIsDuplicate(false)
        setIsEdit(false)
        setPlanID(id)
        setTierModificationType(id ? TierModificationType.EDIT : TierModificationType.ADD)
    }

    const getGridTitle = () => {
        const totalPlans = Plans.length;
        const totalAddons = Addons.length;
        let title = "";
        switch (true) {
            case totalPlans === 0 && totalAddons === 0:
                title = "";
                break;
            case totalPlans === 1 && totalAddons === 0:
                title = `${totalPlans} ${pageTitles.PLAN}`;
                break;
            case totalPlans !== 0 && totalPlans !== 1 && totalAddons === 0:
                title = `${totalPlans} ${pageTitles.PLANS}`;
                break;
            case totalPlans === 0 && totalAddons === 1:
                title = `${totalAddons} ${pageTitles.ADDON}`;
                break;
            case totalPlans === 0 && totalAddons !== 0 && totalAddons !== 1:
                title = `${totalAddons} ${pageTitles.ADDONS}`;
                break;
            case totalPlans !== 0 && totalPlans !== 1 && totalAddons === 1:
                title = `${totalPlans} ${pageTitles.PLANS} and ${totalAddons} ${pageTitles.ADDON}`;
                break;
            case totalPlans === 1 && totalAddons !== 0 && totalAddons !== 1:
                title = `${totalPlans} ${pageTitles.PLAN} and ${totalAddons} ${pageTitles.ADDONS}`;
                break;
            case totalPlans === 1 && totalAddons === 1:
                title = `${totalPlans} ${pageTitles.PLAN} and ${totalAddons} ${pageTitles.ADDON}`;
                break;
            default:
                title = `${totalPlans} ${pageTitles.PLANS} and ${totalAddons} ${pageTitles.ADDONS}`;
        }
        return title;
    }

    return (
        (showFilters && IsMobileDevice) ?
            <FilterComponent
                Filters={filterOptions}
                HandleApplyFilters={handleApplyFilters}
                OnClose={handleCloseFilter}
            /> :
            <div>
                {showTierForm && IsMobileDevice && <SubpageHeaderComponent HeaderText={`${IsEdit ? "Edit Tier" : IsDuplicate ? "Duplicate Tier" : "Add Tier"}`} PreviousPage={() => closeTierForm} />}
                {
                    <div>
                        <Grid container className={`${IsMobileDevice ? 'px-2' : ''}`}>
                            <div className="d-flex justify-between w-p-100">
                                <PageHeaderComponent
                                    HeaderText={"Plans"}
                                    GridTitle={getGridTitle()}
                                    Count={Plans.length + Addons.length}
                                    Reload={() => LoadPlans(dispatch)}
                                    Actions={[
                                        {
                                            OnClick: () => openEditPlan('addPlan'),
                                            ButtonLabel: buttonLabels.ADD_NEW_TIER,
                                            Icon: AddNewTierIcon,
                                            ClassName: "mr-2",
                                            Variant: "primary-btn",
                                        },
                                        {
                                            OnClick: () => openAddNewAddOnPlan(''),
                                            ButtonLabel: buttonLabels.ADD_NEW_ADDON_PLAN,
                                            Icon: AddNewTierDarkIcon,
                                            ClassName: "mr-2",
                                            Variant: "secondary-btn",
                                        },
                                    ]}
                                    ShowFilterIcon={true}
                                    IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                    HandleFilter={handleClickFilter}
                                    onSearch={searchPlans}
                                    PlaceHolder={"Find a Plan..."}
                                    ShowMultiActionButtons={false}
                                />
                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={handleCloseFilter}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    classes={{ paper: `min-w-40 ${showFilterOptions ? "min-h-40" : ""}` }}
                                >
                                    <FilterComponent
                                        Filters={filterOptions}
                                        HandleApplyFilters={handleApplyFilters}
                                        OnClose={handleCloseFilter}
                                    />
                                </Popover>
                            </div>
                            <Grid item xs={12} className={`${IsMobileDevice ? 'mt-2 h-v-73' : ''} scroll pb-2`}>
                                <Grid container direction="row" alignItems={IsMobileDevice ? "center" : "center"} >
                                    {
                                        LoadingPlans || loading ?
                                            <Grid xl={3} lg={3} md={6} sm={8} item className='my-2 mx-4'>
                                                <AnimateLoader LoaderAnimation={TierLoader} className={"w-p-100"} style={{ maxWidth: "330px" }} />
                                            </Grid>
                                            : PlanCards()
                                    }
                                </Grid>
                                <Grid container direction="row" alignItems="center" className="my-10" >
                                    {!(LoadingPlans || loading) && AdOns()}
                                </Grid>
                                <Grid container direction="row" alignItems="center" className="my-10 h5-regular" >
                                    {!(LoadingPlans || loading) && (filterItems(Plans, filterOptions).length < 1 && filterItems(Addons, filterOptions).length < 1) && emptyLabels.TIERS}
                                </Grid>
                            </Grid>
                            {
                                show &&
                                <Confirm_Dialog
                                    ButtonName={action || ""}
                                    onClose={closeConfirmDialog}
                                    Show={show}
                                    Text={text}
                                    HideCancel={false}
                                    Loading={loading}
                                />
                            }
                            {
                                IsAddNewAddOn &&
                                <AddNewAddOnComponent
                                    Features={allFeatures}
                                    isDuplicate={IsDuplicate}
                                    isEdit={IsEdit}
                                    onClose={closeTierForm}
                                    show={IsAddNewAddOn}
                                    Type={tierModificationType}
                                    Tier={[...Addons].find(x => x.PlanID === planID)}
                                    refreshPlan={() => LoadPlans(dispatch)}
                                    IsMobileDevice={IsMobileDevice}
                                />
                            }
                        </Grid>
                    </div>
                }
            </div >
    )
}


export default Tier;